export default "/_next/static/chunks/fonts/din-medium-webfont-bdcb3f1784eb49b2cbf87aa22015c2d2.ttf";